/** A chamada do resumo do painel (ISSUE-210). */
import api from './api'
import { resumoSchema, type Resumo } from '@/schemas/dashboard'

export const dashboardService = {
  /**
   * Busca o resumo da organização.
   *
   * Recebe um `AbortSignal` porque a troca de organização precisa **abortar** a
   * leitura em voo: sem isso, resposta lenta da organização anterior chega
   * depois e sobrescreve a da nova — e a pessoa lê número de outro escritório.
   */
  async resumo(organizationId: string, signal?: AbortSignal): Promise<Resumo> {
    const { data } = await api.get(
      `/organizations/${organizationId}/dashboard`,
      { signal }
    )
    return resumoSchema.parse(data)
  },
}
